import { getApiB2bGetStatics } from '/api/sdk.gen';
import type { Dispatch } from '/business/shared/state/actions/types';

const getStaticProps = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'INITIATE_STATIC_PROP_LOAD_STARTED', timestamp: Date.now() });
    const { data: staticProps } = await getApiB2bGetStatics();

    dispatch({ type: 'INITIATE_STATIC_PROP_LOAD_FULFILLED', staticProps });
    return staticProps;
  } catch (error) {
    dispatch({ type: 'INITIATE_STATIC_PROP_LOAD_REJECTED', error });
    throw error;
  }
};

export default getStaticProps;
